// Utility helpers
export const formatGBP = (n) => {
  const num = Number(n || 0);
  return `£${num.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatCostDisplay = (task) => {
  if (!task) return formatGBP(0);
  if (task.cost_type === "range") {
    return `${formatGBP(task.cost_min)} – ${formatGBP(task.cost_max)}`;
  }
  return formatGBP(task.cost);
};

export const formatDateUK = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso.length > 10 ? iso : iso + "T00:00:00");
    if (isNaN(d)) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  } catch {
    return iso;
  }
};

export const toISODate = (uk) => {
  // uk: dd/mm/yyyy or yyyy-mm-dd
  if (!uk) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(uk)) return uk.slice(0, 10);
  const m = uk.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return uk;
};

export const STATUS_COLORS = {
  "Not Started": "bg-zinc-100 text-zinc-700 border-zinc-200",
  "In Progress": "bg-blue-100 text-blue-800 border-blue-200",
  "Completed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "On Hold": "bg-amber-100 text-amber-800 border-amber-200",
  "Invoiced": "bg-violet-100 text-violet-800 border-violet-200",
  "Draft": "bg-slate-100 text-slate-700 border-slate-200",
  "Sent": "bg-blue-100 text-blue-800 border-blue-200",
  "Client Selected": "bg-teal-100 text-teal-800 border-teal-200",
  "Accepted": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Rejected": "bg-red-100 text-red-800 border-red-200",
};

export const STATUS_DOT = {
  "Not Started": "bg-zinc-400",
  "In Progress": "bg-blue-500",
  "Completed": "bg-emerald-500",
  "On Hold": "bg-amber-500",
  "Invoiced": "bg-violet-500",
  "Draft": "bg-slate-400",
  "Sent": "bg-blue-500",
  "Client Selected": "bg-teal-500",
  "Accepted": "bg-emerald-500",
  "Rejected": "bg-red-500",
};

export const STATUS_BG = {
  // Projects
  "Not Started": "bg-rose-50 border-rose-200",
  "In Progress": "bg-green-100 border-green-200",
  "Completed": "bg-purple-50 border-purple-200",
  "On Hold": "bg-orange-50 border-orange-200",
  "Invoiced": "bg-sky-50 border-sky-200",
  // Quotes
  "Draft": "bg-rose-50 border-rose-200",
  "Sent": "bg-orange-50 border-orange-200",
  "Client Selected": "bg-teal-50 border-teal-200",
  "Accepted": "bg-emerald-50 border-emerald-200",
  "Rejected": "bg-zinc-100 border-zinc-200",
};

export const PROJECT_STATUSES = ["Not Started", "In Progress", "Completed", "On Hold", "Invoiced"];
export const QUOTE_STATUSES = ["Draft", "Sent", "Client Selected", "Accepted", "Rejected"];
export const TASK_STATUSES = ["Not Started", "In Progress", "Completed", "On Hold"];

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return String(d);
};

// Human-readable byte size — e.g. 2_415_616 -> "2.3 MB". Returns "" for null/undefined.
export const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "";
  const b = Number(bytes);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
